<!-- 
    Purpose: To show the selected task details on sidebar for mobile view
-->
<template>
  <div class="">
    <!-- {{ isExtension }} -->
    <v-progress-linear
      v-if="!isExtension"
      v-show="fetchLinearLoader"
      color="#2a206a"
      class="px-2"
      indeterminate
      style="position: absolute; top: 0px"
    ></v-progress-linear>
    <div
      v-if="!isExtension"
      style="position: absolute; top: 10px; z-index: 1"
      class="d-flex w-100 justify-end align-start"
    >
      <v-btn
        right
        elevation="0"
        small
        text
        class="mt-n1 mr-3 success-text text-capitalize"
        v-if="!isExtension && $vuetify.breakpoint.xs"
        @click="$router.push({ name: 'mobileTasks' })"
      >
        <span class="text-right caption font-weight-bold">+ Create Task</span>
      </v-btn>
    </div>
    <div
      class="px-3 overflow-scroll"
      :class="
        isExtension
          ? ''
          : getSelectedCompany.role == 'employee'
          ? `table-height-with-assign-btn mt-2`
          : getActiveTask
          ? `table-height-with-assign-btn mt-2`
          : `table-height-without-assign-btn mt-2`
      "
      :style="{
        height: isExtension
          ? `calc(100vh - 145px)`
          : getSelectedCompany.role == 'employee'
          ? `calc(113vh - 245px)`
          : getActiveTask
          ? `calc(113vh - 245px)`
          : `calc(100vh - 160px)`,
      }"
    >
      <!-- Date picker menu for time entries -->
      <v-menu
        v-model="entryDatePicker"
        :close-on-content-click="false"
        :nudge-right="40"
        transition="scale-transition"
        offset-y
        z-index="99"
        min-width="auto"
        :position-x="x"
        :position-y="y"
      >
        <v-date-picker v-model="entryDate"></v-date-picker>
      </v-menu>
      <!-- Tasks -->
      <div v-if="getTasks.length">
        <v-card
          :disabled="getDisbaleFlag == true"
          minHeight="110px"
          v-for="task in getActiveTask
            ? [getActiveTask].concat(
                getTasks.filter((item) => {
                  return item.task_id != getActiveTask.task_id;
                })
              )
            : getTasks"
          :key="task.task_id"
          @click="editTask(task)"
          class="task-card-shadow"
        >
          <!-- Task details -->
          <div class="pa-2 mt-2 task-card-border rounded d-flex align-center">
            <!-- Expansion Icon -->
            <div class="mr-2">
              <v-btn
                v-visible="task.interval && task.interval.length"
                class="expanding-chevron-bg px-0"
                icon
                x-small
                @click.stop="expand(task.task_id)"
              >
                <v-icon color="#1CC283">{{
                  !isExpanded(task.task_id)
                    ? "mdi-chevron-right"
                    : "mdi-chevron-down"
                }}</v-icon>
              </v-btn>
            </div>
            <!-- Card Body -->
            <div class="w-100">
              <!-- Labels -->
              <div>
                <span v-for="(label, index) in task.labels" :key="index">
                  <v-chip
                    v-if="
                      getAllLabels.find((item) => {
                        return item.id == label;
                      }) && index < 4
                    "
                    class="mr-1 pointer"
                    label
                    :style="
                      showLabelName
                        ? 'height:20px;border-radius:2px;max-width: 140px;font-size:12px'
                        : 'height:8px;width:40px'
                    "
                    x-small
                    :color="
                      getAllLabels.find((element) => {
                        return element.id == label;
                      }).hexcode
                    "
                    @click.stop="
                      showLabelName == null
                        ? (showLabelName = task)
                        : (showLabelName = null)
                    "
                  >
                    <span
                      class="text-truncate d-inline-block white--text text-capitalize font-weight-bold"
                      style="max-width: 140px"
                    >
                      {{
                        showLabelName
                          ? getAllLabels.find((element) => {
                              return element.id == label;
                            }).title
                          : ""
                      }}
                    </span>
                  </v-chip>
                </span>
                <v-menu offset-y>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon
                      v-if="task.labels.length > 4"
                      v-bind="attrs"
                      v-on="on"
                      color="#757096"
                      class="pointer"
                      small
                      >mdi-dots-horizontal</v-icon
                    >
                  </template>
                  <span :class="isMac ? 'edited_scrollbar' : ''">
                    <v-card
                      max-width="300px"
                      max-height="200px"
                      class="y-scroll shadow"
                    >
                      <v-card-title class="pt-1 pb-0 px-1">
                        <v-spacer></v-spacer>
                        <v-icon color="#757096" x-small>mdi-close</v-icon>
                      </v-card-title>
                      <v-card-text>
                        <span
                          v-for="(label, index) in task.labels"
                          :key="index"
                        >
                          <v-chip
                            v-if="
                              getAllLabels.find((item) => {
                                return item.id == label;
                              })
                            "
                            class="mr-1 mb-1 pointer"
                            label
                            style="'height:20px;border-radius:2px;max-width: 140px;font-size:12px'
                    "
                            x-small
                            :color="
                              getAllLabels.find((element) => {
                                return element.id == label;
                              }).hexcode
                            "
                          >
                            <span
                              class="text-truncate d-inline-block white--text text-capitalize font-weight-bold"
                              style="max-width: 140px"
                            >
                              {{
                                getAllLabels.find((element) => {
                                  return element.id == label;
                                }).title
                              }}
                            </span>
                          </v-chip>
                        </span>
                      </v-card-text>
                    </v-card>
                  </span>
                </v-menu>
              </div>
              <!-- Flag, Ticket, Priority, Status, Options -->
              <div class="d-flex align-center">
                <!-- Flag -->
                <!-- Ticket Number -->
                <span
                  v-if="getTaskColumn('sr_no')"
                  class="ticket-font ticket-no-font mr-3"
                  >#{{ task.sr_no }}</span
                >
                <!-- Priority -->
                <div
                  class="d-flex align-center justify-center"
                  v-if="getTaskColumn('priority')"
                >
                  <v-menu nudge-bottom="25">
                    <template v-slot:activator="{ on }">
                      <v-chip
                        v-on="on"
                        class="due_date-chip-xs caption my-1 mr-1 px-0 text-capitalize"
                        label
                        small
                        dark
                        :class="
                          task.assigned_by.id != getLoggedInUser.id &&
                          getSelectedCompany.role == 'employee'
                            ? ''
                            : 'pointer'
                        "
                        :color="
                          task.priority == 'high'
                            ? 'priority-red-chip-color red-chip-texts d-flex justify-center'
                            : task.priority == 'medium'
                            ? 'priority-orange-chip-color orange-chip-texts d-flex justify-center'
                            : task.priority == 'low'
                            ? 'priority-yellow-chip-color yellow-chip-texts d-flex justify-center'
                            : task.assigned_by.id != getLoggedInUser.id &&
                              getSelectedCompany.role == 'employee'
                            ? 'transparent-chip-color w-100 caption px-0 font-italic grey--text'
                            : 'grey-chip-color d-flex justify-center px-2 body-2 listing-hover'
                        "
                      >
                        {{
                          task.priority
                            ? task.priority
                            : task.assigned_by.id != getLoggedInUser.id &&
                              getSelectedCompany.role == "employee"
                            ? "Priority not set"
                            : "Set priority"
                        }}
                      </v-chip>
                    </template>
                    <div
                      v-if="
                        !(
                          task.assigned_by.id != getLoggedInUser.id &&
                          getSelectedCompany.role == 'employee'
                        )
                      "
                      class="bg-white pointer py-2"
                    >
                      <div
                        v-for="(priority, i) in ['low', 'medium', 'high']"
                        :key="i"
                        :class="
                          task.priority && task.priority == priority
                            ? 'bg-selected'
                            : ''
                        "
                        class="body-2 listing-hover dark-purple-text text-capitalize px-2 py-1"
                        @click="setPriority(task, priority)"
                      >
                        <span>{{ priority }}</span>
                      </div>
                    </div>
                  </v-menu>
                </div>
                <!-- Status -->
                <div
                  v-if="getTaskColumn('status')"
                  class="ml-0 d-flex align-center pointer justify-center px-0"
                >
                  <v-chip
                    class="due_date-chip-xs caption px-0 d-flex justify-center"
                    small
                    label
                    :class="
                      task.overdue && task.status != 'completed'
                        ? 'red-chip-color'
                        : task.status === 'active' && task.running
                        ? 'blue-chip-color'
                        : task.status === 'active' && !task.running
                        ? 'status-paused-chip-color'
                        : task.status === 'pending'
                        ? 'status-yellow-chip-color'
                        : task.status == 'completed' && task.archived_at != null
                        ? 'status-blue-chip-color'
                        : task.status === 'completed'
                        ? 'green-chip-color px-2'
                        : ''
                    "
                  >
                    <span class="text-capitalize">
                      <v-progress-circular
                        v-if="updateStatusLoader && setTaskId == task.task_id"
                        indeterminate
                        class="ml-1"
                        :size="17"
                        :width="1"
                      ></v-progress-circular>
                      <span v-else>
                        {{
                          task.overdue && task.status != "completed"
                            ? "Overdue"
                            : task.status === "pending"
                            ? "Pending"
                            : task.status === "completed" &&
                              task.archived_at != null
                            ? "Archived"
                            : task.status === "completed"
                            ? "Completed"
                            : task.status === "active" && task.running
                            ? "Active"
                            : task.status === "active" && !task.running
                            ? "Paused"
                            : ""
                        }}</span
                      >
                    </span>
                  </v-chip>
                </div>
                <v-spacer></v-spacer>

                <div
                  v-if="
                    getSelectedCompany.role != 'employee' ||
                    task.assigned_by.id == getLoggedInUser.id ||
                    task.is_flagged
                  "
                  class=""
                >
                  <v-icon
                    class="pointer"
                    @click.stop="
                      getSelectedCompany.role == 'employee' &&
                      task.assigned_by.id != getLoggedInUser.id
                        ? openSnackbar(true, 'Only assigner can flag task')
                        : flagTask(task, !task.is_flagged)
                    "
                    :color="task.is_flagged ? '#D52B5D' : '#2a206a'"
                    size="1.4em"
                  >
                    {{
                      task.is_flagged ? "mdi-bookmark" : "mdi-bookmark-outline"
                    }}</v-icon
                  >
                </div>
              </div>

              <!-- Title -->

              <div class="d-flex align-center">
                <div
                  v-line-clamp:20="2"
                  class="text-capitalize mb-1 dark-purple-text"
                  :class="task.title ? 'font-weight-bold body-2' : 'body-2'"
                  style="
                    word-wrap: break-word !important;
                    word-break: break-word !important;
                    max-width: 100%;
                  "
                >
                  {{ task.title ? task.title : "no title" }}
                </div>
              </div>

              <!-- Project -->
              <div v-if="getTaskColumn('project')" class="d-flex pointer">
                <!-- Employee case -->
                <v-icon
                  v-if="task.project && 'id' in task.project"
                  small
                  color="#322583"
                  class="mx-0 pa-0 ml-n1"
                  >mdi-circle-medium</v-icon
                >
                <span
                  class="dark-purple-text text-capitalize d-inline-block text-truncate listing-hover body-2"
                  style="max-width: 80%"
                  v-if="task.project && 'id' in task.project"
                >
                  {{ task.project.name }}
                </span>
                <span v-else class="font-italic grey--text caption"
                  >no project</span
                >
              </div>

              <!-- Due date, Project, Time Spent, Play/Pause, Complete, Comments -->
              <div class="d-flex align-center w-100">
                <!-- Due date -->
                <div
                  v-if="getTaskColumn('due_date')"
                  class="d-flex align-center justify-center"
                >
                  <v-menu
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                    nudge-right="15"
                  >
                    <template v-slot:activator="{ on }">
                      <div
                        v-if="!task.due_date"
                        v-on="on"
                        @click.stop="
                          (selectedTaskDate = task.task_id),
                            (selection = task.task_id),
                            task.due_date
                              ? (date = task.due_date)
                              : (date = new Date().toISOString().substr(0, 10))
                        "
                        class="pointer d-flex align-center"
                      >
                        <span class="grey--text font-italic caption"
                          >No Due Date</span
                        >
                      </div>
                      <div
                        v-else
                        v-on="on"
                        @click.stop="selectedTaskDate = task.task_id"
                        class="due-date-text d-flex align-center"
                        :class="
                          getSelectedCompany.role == 'employee' &&
                          task.assigned_by.id != getLoggedInUser.id
                            ? ''
                            : 'pointer'
                        "
                      >
                        <v-icon
                          :color="
                            task.due_date === getCurrentDate()
                              ? '#136195'
                              : task.due_date ===
                                getTommorrowDate(task.due_date)
                              ? '#29815f'
                              : task.due_date > getCurrentDate()
                              ? '#29815f'
                              : task.due_date < getCurrentDate()
                              ? '#a82335'
                              : '#7f5f01'
                          "
                          small
                          class="mr-1"
                          >mdi-calendar-outline</v-icon
                        >
                        <span
                          class="blue-chip-text"
                          v-if="task.due_date === getCurrentDate()"
                        >
                          Today
                        </span>
                        <span
                          class="green-chip-text"
                          v-else-if="
                            task.due_date === getTommorrowDate(task.due_date)
                          "
                        >
                          Tomorrow
                        </span>
                        <span
                          class="green-chip-text"
                          v-else-if="task.due_date > getCurrentDate()"
                        >
                          {{ getDueDate(task.due_date) }}
                        </span>
                        <span
                          class="red-chip-text"
                          v-else-if="task.due_date < getCurrentDate()"
                        >
                          {{ getDueDate(task.due_date) }}
                        </span>
                      </div>
                    </template>
                    <v-date-picker
                      id="task-page-due-date"
                      v-if="
                        selectedTaskDate == task.task_id &&
                        (getSelectedCompany.role != 'employee' ||
                          task.assigned_by.id == getLoggedInUser.id)
                      "
                      v-model="date"
                      color="#2a206a"
                      @input="
                        getPendingTimer &&
                        getPendingTimer.task_id == task.task_id
                          ? () => {}
                          : updateDueDate(date, task),
                          (dateMenu = false)
                      "
                    >
                      <v-spacer></v-spacer>
                      <v-btn
                        @click="
                          getPendingTimer &&
                          getPendingTimer.task_id == task.task_id
                            ? () => {}
                            : updateDueDate(null, task),
                            (dateMenu = false),
                            (task.due_date = null)
                        "
                        class="text-capitalize pointer caption"
                        text
                        color="#2a206a"
                        outlined
                      >
                        Reset
                      </v-btn>
                    </v-date-picker>
                  </v-menu>
                </div>
                <v-divider
                  color="#EDEBF9"
                  class="my-2 ml-2"
                  vertical
                  v-if="
                    getTaskColumn('members.duration') &&
                    getTaskColumn('due_date')
                  "
                ></v-divider>
                <!-- Time Spent (duration) -->
                <div
                  v-if="getTaskColumn('members.duration')"
                  class="d-flex align-center justify-center listing-hover body-2 px-2 pointer"
                >
                  <v-menu
                    v-if="getSelectedCompany.role != 'employee'"
                    content-class="pa-0 bg-white"
                    offset-y
                    bottom
                    width="600px"
                    nudge-left="88px"
                  >
                    <template v-slot:activator="{ on }">
                      <div class="timer-font d-flex align-center" v-on="on">
                        <v-icon color="#2a206a" class="mr-1" x-small
                          >mdi-clock-outline</v-icon
                        >
                        {{
                          getActiveTask && getActiveTask.task_id == task.task_id
                            ? getMyDuration(task)
                            : getTotalDuration(task)
                        }}
                      </div>
                    </template>

                    <div
                      class="table-header-bg dark-purple-text font-weight-bold w-100 py-2 px-3"
                    >
                      Durations
                    </div>
                    <v-list class="overflow-scroll" scrollabe max-height="155">
                      <v-list-item
                        class="d-flex"
                        v-for="member in task.members"
                        :key="member.id"
                      >
                        <profileImage
                          inline
                          v-show="member.image ? ':src' : ':username'"
                          :src="member.image"
                          :username="member.name ? member.name : member.email"
                          :size="30"
                          :userProfile="true"
                          :circular="true"
                          class="my-2 text-light d-inline mr-2"
                        >
                        </profileImage>
                        <span
                          max-width="100px"
                          class="d-inline-block caption text-capitalize text-truncate mr-1"
                        >
                          {{ member.name ? member.name : member.email }} :
                        </span>
                        <v-spacer></v-spacer>
                        <span class="caption d-inline-block">
                          {{
                            member
                              ? member.id == getLoggedInUser.id
                                ? getMyDuration(task)
                                : format(member.duration)
                              : ""
                          }}
                        </span>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                  <div v-else class="mr-2">
                    {{ getTotalDuration(task) }}
                  </div>
                </div>
                <v-spacer></v-spacer>
                <!-- Play/Pause, Complete, Comments -->
                <div class="d-flex align-center">
                  <!-- Play/Pause -->
                  <v-icon
                    v-visible="
                      task.members.find((item) => {
                        return item.id == getLoggedInUser.id;
                      })
                    "
                    color="#1cc283"
                    size="1.5em"
                    class="my-1"
                    :class="
                      getActiveTask && getActiveTask.task_id == task.task_id
                        ? 'stop-icon'
                        : 'play-icon'
                    "
                    @click.stop="
                      getActiveTask && getActiveTask.task_id == task.task_id
                        ? stopTask()
                        : playTask(task)
                    "
                    >{{
                      getActiveTask && getActiveTask.task_id == task.task_id
                        ? "mdi-pause-circle-outline"
                        : "mdi-play-circle-outline"
                    }}</v-icon
                  >
                  <!-- Complete -->
                  <v-icon
                    v-if="task.status != 'completed'"
                    v-show="
                      task.assigned_by.id == getLoggedInUser.id ||
                      getSelectedCompany.role != 'employee'
                    "
                    color="#1cc283"
                    :disabled="
                      (setTaskId == task.task_id &&
                        disableStatusIcon == true) ||
                      (getSelectedCompany.role == 'employee' &&
                        task.assigned_by.id != getLoggedInUser.id)
                    "
                    class="pointer ml-1"
                    @click.stop="
                      getPendingTimer && getPendingTimer.task_id == task.task_id
                        ? () => {}
                        : (setTaskId = task.task_id),
                        updateTaskStatus(task, 'completed')
                    "
                    >mdi-checkbox-blank-outline</v-icon
                  >
                  <!-- Incomplete -->
                  <v-icon
                    v-if="task.status == 'completed'"
                    :disabled="
                      (setTaskId == task.task_id &&
                        disableStatusIcon == true) ||
                      (getSelectedCompany.role == 'employee' &&
                        task.assigned_by.id != getLoggedInUser.id)
                    "
                    color="#13865a "
                    class="pointer ml-1"
                    @click.stop="
                      (setTaskId = task.task_id), checkTaskStatus(task)
                    "
                    >mdi-checkbox-marked</v-icon
                  >
                  <!-- Comments -->
                  <v-badge
                    :content="
                      parseInt(task.comments_count) < 100
                        ? task.comments_count
                        : '99+'
                    "
                    v-if="task.comments_count"
                    color="green"
                    :class="[
                      { 'mr-3': parseInt(task.comments_count) > 100 },
                      { 'mr-2': parseInt(task.comments_count) >= 9 },
                      { 'mr-2': parseInt(task.comments_count) < 9 },

                      {
                        'style-badge':
                          task.assigned_by.id == getLoggedInUser.id,
                      },
                    ]"
                    overlap
                  >
                    <img
                      :id="'comment-' + task.task_id"
                      @click.stop="
                        getPendingTimer &&
                        getPendingTimer.task_id == task.task_id
                          ? () => {}
                          : openCommentModal(task)
                      "
                      height="22px"
                      width="22px"
                      class="dark-purple-text pointer mx-1"
                      :src="comment_icon"
                      alt="comment icon"
                    />
                  </v-badge>
                  <img
                    v-else
                    @click.stop="
                      getPendingTimer && getPendingTimer.task_id == task.task_id
                        ? () => {}
                        : openCommentModal(task)
                    "
                    height="22px"
                    width="22px"
                    class="dark-purple-text pointer mx-1"
                    :src="comment_icon"
                    alt="comment icon"
                  />
                </div>
              </div>

              <!-- Ticket Number -->
              <!-- <span v-if="getTaskColumn('sr_no')" class="ticket-font mr-1"
                >#{{ task.sr_no }}</span
              > -->
            </div>
          </div>
          <!-- Time Entries -->
          <div
            class="mt-n1 task-card-bg task-card-border"
            v-if="isExpanded(task.task_id)"
          >
            <div
              class="px-2"
              v-for="(entry, index) in task.interval"
              :key="entry.entry_id"
            >
              <div class="d-flex align-center py-3 px-2">
                <div
                  v-show="
                    !getActiveTimeEntry ||
                    (getActiveTimeEntry &&
                      entry.entry_id != getActiveTimeEntry.entry_id)
                  "
                >
                  <v-menu
                    :close-on-content-click="false"
                    ref="editMenu"
                    width="100vw"
                    tile
                    bottom
                    offset-y
                    :close-on-click="!entryDatePicker"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <div
                        class="d-flex justify-start body-2 time-entries-font"
                        v-on="on"
                        v-bind="attrs"
                        @click="
                          selectedInterval = Object.assign({}, entry);
                          timeEntryMenu = true;
                        "
                      >
                        <span class="pointer mx-1">
                          {{ gethhmm(entry.start_time) }}</span
                        >
                        -
                        <span class="pointer mx-1">
                          {{
                            gethhmm(entry.end_time)
                              ? gethhmm(entry.end_time)
                              : ""
                          }}
                        </span>
                      </div>
                    </template>
                    <!-- manual time dropdown -->
                    <v-card width="100vw" outlined tile v-if="timeEntryMenu">
                      <v-card-text class="black--text px-2">
                        <div class="d-flex align-center">
                          <!-- Icons -->
                          <div class="d-flex flex-column mx-1">
                            <v-btn
                              :class="$vuetify.breakpoint.xs ? 'mt-1' : 'my-2'"
                              color="black"
                              light
                              icon
                              @click="openEntryDateMenu($event)"
                            >
                              <v-icon>mdi-calendar-outline</v-icon>
                            </v-btn>

                            <v-icon color="black">mdi-clock-outline</v-icon>
                          </div>
                          <!-- Chips -->
                          <div>
                            <!-- Date Chips -->
                            <div class="d-flex align-center my-1">
                              <!-- start date -->
                              <v-chip
                                label
                                small
                                class="font-weight-light date-time-chip light-purple-bg py-1 px-2 pointer"
                              >
                                {{ entryDate }}
                              </v-chip>
                              <div class="mx-1">-</div>
                              <!-- end date -->
                              <v-chip
                                label
                                small
                                class="font-weight-light date-time-chip light-purple-bg py-1 px-2 pointer"
                              >
                                {{ entryDate }}
                              </v-chip>
                            </div>
                            <!-- Time Chips -->
                            <div class="d-flex align-center">
                              <!-- Start Time -->
                              <input
                                type="time"
                                style="border-radius: 5px; width"
                                ref="startTime"
                                v-model="startTime"
                                class="d-block date-time-chip font-weight-light light-purple-bg"
                                :class="
                                  $vuetify.breakpoint.xs
                                    ? 'time-style-sm'
                                    : 'time-style'
                                "
                              />
                              <div class="mx-1">-</div>
                              <!-- Stop Time -->
                              <input
                                type="time"
                                style="border-radius: 5px"
                                ref="endTime"
                                v-model="endTime"
                                :class="
                                  $vuetify.breakpoint.xs
                                    ? 'time-style-sm'
                                    : 'time-style'
                                "
                                class="d-block date-time-chip light-purple-bg font-weight-light"
                              />
                            </div>
                          </div>
                          <!-- Labels -->
                          <div class="d-flex flex-column mx-3">
                            <span
                              class="ticket-font italic grey--text mb-3 mt-1"
                              >(From - To)</span
                            >
                            <span class="ticket-font italic grey--text"
                              >(Start - End Time)</span
                            >
                          </div>
                        </div>
                        <!-- Range slider -->
                        <v-range-slider
                          hide-details
                          v-model="timeEntryRange"
                          @end="updateInterval"
                          :max="1440"
                          :step="1"
                          :min="0"
                          color="#1CC283"
                          track-color="#E6E6E6"
                          track-fill-color="#9185E0"
                        ></v-range-slider>
                        <RangeSliderLabels />
                        <div class="d-flex mt-2 align-center">
                          <v-spacer></v-spacer>
                          <v-btn
                            @click="editTimeEntry(entry, task)"
                            small
                            class="btn-success white--text"
                            >Save
                          </v-btn>
                        </div>
                      </v-card-text>
                    </v-card>
                  </v-menu>
                </div>
                <div
                  v-show="
                    getActiveTimeEntry &&
                    entry.entry_id == getActiveTimeEntry.entry_id
                  "
                >
                  <span
                    class="pointer underline mx-1"
                    v-text="
                      entry
                        ? entry.start_time
                          ? entry.start_time.slice(11, 16)
                          : ''
                        : ''
                    "
                  >
                  </span>
                </div>
                <v-spacer></v-spacer>
                <div class="body-2 time-entries-font">
                  {{ getDurationHM(entry.duration) }}
                </div>
                <v-icon
                  color="#2a206a"
                  @click.stop="deleteTimeEntry(entry, task)"
                  class="ml-3"
                  >mdi-trash-can-outline</v-icon
                >
              </div>
              <v-divider
                v-if="index < task.interval.length - 1"
                class="dusty-purple-text"
                color="#EDEBF9"
              ></v-divider>
            </div>
          </div>
        </v-card>
      </div>
      <div
        v-else
        style="height: 65vh"
        class="w-100 d-flex flex-column justify-center align-center"
      >
        <div class="dusty-purple-text text-capitalize">No task found</div>
        <div>
          <v-icon color="#CBC9E6" size="40">mdi-file-document-outline</v-icon>
        </div>
      </div>
      <!-- Edit task Sidebar -->
      <MobileTaskSidebar :drawer.sync="drawer" :taskToEdit="taskToEdit" />
      <!-- Comments -->
      <template v-show="openCommentDialog">
        <CommentsDialogBox
          :openCommentDialog.sync="openCommentDialog"
          :taskDetails="details"
          :getTaskComments="getTaskComments"
        />
      </template>
    </div>
    <!-- Pagination -->
    <div
      v-if="!getTasksSkeletonLoader && getTasks.length"
      class="d-flex justify-space-between"
    >
      <!-- Per page -->
      <div class="d-flex my-1 align-center px-0">
        <div style="width: 60px" class="pa-0 d-flex mx-1">
          <v-select
            id="tasklist-pg-selector"
            style="display: inline-table"
            hide-details
            dense
            solo
            flat
            class="ticket-font caption"
            :items="[5, 10, 25, 50, 100]"
            :value="getSearchedPerPage"
            @change="changePerPage"
          />
        </div>
        <!--Download CSV-->
        <v-menu offset-y>
          <template #activator="{ on: onMenu }">
            <v-tooltip
              :disabled="$vuetify.breakpoint.xs"
              color="#302277"
              top
              content-class="arrow-down"
            >
              <template #activator="{ on: onTooltip }">
                <v-btn
                  class="text-capitalize dark-purple-text d-flex d-xs-flex align-center mt-2 mb-2"
                  outlined
                  text
                  small
                  v-on="{ ...onMenu, ...onTooltip }"
                >
                  <v-icon small class="mx-1">mdi-printer</v-icon>
                </v-btn>
              </template>

              <span>Download</span>
            </v-tooltip>
          </template>
          <v-list class="pa-0 body-2">
            <v-list-item class="listing-hover pointer" @click="download('csv')">
              <img
                src="@/assets/images/Csv_icon.png"
                height="16px"
                class="mr-1"
              />
              <v-list-item-content>CSV</v-list-item-content>
            </v-list-item>
            <v-list-item class="listing-hover pointer">
              <img
                src="@/assets/images/Excel_icon.png"
                height="20px"
                class="mr-1"
              />
              <a
                class="dropdown-item black--text text-decoration-none"
                href="#"
              >
                <download-excel
                  :data="excelDownload.data"
                  :labels="excelDownload.labels"
                  :name="excelDownload.name"
                  worksheet="abc"
                  >Excel</download-excel
                >
              </a>
            </v-list-item>
          </v-list>
        </v-menu>
      </div>

      <!-- Current page -->
      <div
        style="width: 80vw"
        class="d-flex justify-end align-center flex-column py-1 px-0 ticket-font dusty-purple-text"
      >
        <v-pagination
          style="width: 35vw"
          v-if="getTasksPagination"
          id="pagination"
          class="my-1"
          :value="getSearchedPage"
          :length="getTasksPagination.last_page"
          circle
          :total-visible="3"
          @input="fetchPage"
        ></v-pagination>
        <span class="d-flex justify-center ticket-font mx-1">
          {{
            getTasksPagination && getTasksPagination.from
              ? getTasksPagination.from
              : 0
          }}-{{
            getTasksPagination && getTasksPagination.to
              ? getTasksPagination.to
              : 0
          }}
          of
          {{
            getTasksPagination && getTasksPagination.total
              ? getTasksPagination.total
              : 0
          }}
        </span>
      </div>
    </div>
    <!-- snackbar -->
    <SnackbarNew
      :snackbar.sync="snackbar"
      :snackbarError="snackbarError"
      :snackbarMessage="snackbarMessage"
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { tasksMixin } from "@/mixins/tasksMixin";
import { snackbarMixin } from "@/mixins/snackbarMixin";
import { dateHelpersMixin } from "@/mixins/dateHelpersMixin";
import { rangeSlider } from "@/mixins/rangeSlider";
import { momentHelper } from "@/mixins/momentHelper";
import { eventBus } from "@/main";
import moment from "moment";
import JsonExcel from "vue-json-excel";

export default {
  name: "MobileTaskList",
  components: {
    profileImage: () => import("../../Includes/ProfileImage"),
    SnackbarNew: () => import("@/components/Includes/SnackbarNew"),
    MobileTaskSidebar: () => import("./MobileTaskSidebar"),
    CommentsDialogBox: () => import("../Comments/CommentsDialogBox_latest"),
    RangeSliderLabels: () => import("../RangeSliderLabels"),
    downloadExcel: JsonExcel,
  },
  computed: {
    ...mapGetters([
      "getActiveTask",
      "getTimeEntry",
      "getSelectedCompany",
      "getLoggedInUser",
      "getActiveTimeEntry",
      "getTasks",
      "getPendingTimer",
      "getTaskColumn",
      "getDisbaleFlag",
    ]),
  },
  data() {
    return {
      showLabelName: true,
      loader: false,
      expanded: [],
      taskToEdit: null,
      drawer: false, // Edit task drawer
      x: 0,
      y: 0,
      selectedInterval: {},
      entryDatePicker: false,
      timeEntryMenu: false,
      entryDate: null,
      pending: false,
    };
  },
  mixins: [
    tasksMixin,
    snackbarMixin,
    dateHelpersMixin,
    momentHelper,
    rangeSlider,
  ],
  methods: {
    // Open menu to edit the date of selected time entry
    openEntryDateMenu(event) {
      event.stopPropagation();
      this.x = event.clientX;
      this.y = event.clientY;
      this.entryDatePicker = true;
    },
    // Runs after range slider is moved
    // Calulates intervals for time entries
    updateInterval(range) {
      this.calculateInterval(range);
      this.selectedInterval.start_time = `${this.entryDate} ${this.startTime}`;
      this.selectedInterval.end_time = `${this.entryDate} ${this.endTime}`;
    },
    // Edit Start/End time for any entry
    editTimeEntry(entry, task) {
      let start_time = moment(
        `${this.entryDate} ${this.startTime}`,
        "YYYY-MM-DD HH:mm:ss"
      );
      let end_time = moment(
        `${this.entryDate} ${this.endTime}`,
        "YYYY-MM-DD HH:mm:ss"
      );
      let duration = moment.duration(end_time.diff(start_time)).asSeconds();
      this.$store
        .dispatch("editTimeEntry", {
          company_id: this.getSelectedCompany.id,
          entry_id: entry.entry_id,
          start_time: start_time.format("YYYY-MM-DD HH:mm:ss"),
          end_time: end_time.format("YYYY-MM-DD HH:mm:ss"),
          duration,
          project_id: task.project ? task.project.id : null,
          task_id: task.task_id,
        })
        .catch(() => {
          this.openSnackbar(
            true,
            "The end time must be a date after start time"
          );
        });
      this.timeEntryMenu = false;
    },
    // Delete time entry
    deleteTimeEntry(entry, task) {
      if (
        this.getActiveTimeEntry &&
        entry.entry_id == this.getActiveTimeEntry.entry_id
      ) {
        this.openSnackbar(true, "Cannot delete active time entry");
        return;
      }
      this.$store
        .dispatch("deleteTimeEntry", {
          entry_id: entry.entry_id,
          task,
          loggedInUser: this.getLoggedInUser,
          duration: this.getTimeEntry(task.task_id, entry.entry_id).duration,
        })
        .then(() => {
          this.openSnackbar(false, "Time entry deleted successfully");
        })
        .catch((error) => {
          console.log(error);
        });
    },
    // Selects task for editing
    editTask(task) {
      if (
        !(this.getPendingTimer && this.getPendingTimer.task_id == task.task_id)
      ) {
        this.drawer = !this.drawer;
        this.taskToEdit = task;
        eventBus.$emit("openSideBar");
      }
    },

    // Check if a task is expanded
    isExpanded(id) {
      return this.expanded.find((item) => {
        return item.task_id == id;
      })
        ? this.expanded.find((item) => {
            return item.task_id == id;
          }).expanded
        : false;
    },

    // Expand/collapse a task row
    expand(id) {
      let task = this.expanded.find((item) => {
        return item.task_id == id;
      });
      if (task) {
        task.expanded = !task.expanded;
      }
    },
  },
  watch: {
    // Update expansion array on getting new tasks
    getTasks(value) {
      if (value) {
        for (let task of value) {
          this.expanded.push({ task_id: task.task_id, expanded: false });
        }
      }
    },
    // Time entry being edited
    // Re-initialize range slider if new interval is selected
    selectedInterval(value) {
      if (value) {
        this.entryDate = value.start_time.slice(0, 11);
        this.startTime = value.start_time.slice(11, 16);
        this.endTime = value.end_time.slice(11, 16);
        this.timeEntryRange = [
          moment
            .duration(
              moment(value.start_time.slice(11, 16), "HH:mm:ss").diff(
                moment("00:00:00", "HH:mm:ss")
              )
            )
            .asMinutes(),
          moment
            .duration(
              moment(value.end_time.slice(11, 16), "HH:mm:ss").diff(
                moment("00:00:00", "HH:mm:ss")
              )
            )
            .asMinutes(),
        ];
      }
    },
  },
  mounted() {
    this.fetchLinearLoader = true;
    this.$store.commit("setView", "list");
    // Populating expansion array
    for (let task of this.getTasks) {
      this.expanded.push({ task_id: task.task_id, expanded: false });
    }
  },
};
</script>

<style scoped>
.table-height-with-assign-btn {
  height: calc(100vh - 225px);
}

.table-height-without-assign-btn {
  height: calc(100vh - 205px);
}

.expanding-chevron-bg {
  border: 1px solid #1cc283;

  background-color: rgba(28, 194, 131, 0.12);
}
.ticket-font {
  font-size: 9.5px;
}
.timer-font {
  font-size: 12px;
}
.v-pagination__navigation {
  margin: 0 !important;
  padding: 0 !important;
}
.time-entries-font {
  color: #17123b !important;
}
.ticket-no-font {
  color: #73819b !important
;
}
.due-date-text {
  font-size: 0.6em;
}
</style>
